module.exports = __webpack_public_path__ + "img/3h-白底.035a8834.png";